import React, {useEffect, useMemo, useState} from "react";
import {ComponentPropsFromRoute} from "../../../routers/routers";
import {useTranslate} from "../../../hooks/translate.hook";
import {DocumentsMenu} from "../../common/documents/menu/documents.menu";
import {AccountingSummaryItem} from "../../../models/accounting/summary";
import {summaryService} from "../../../services/accounting/summary.service";
import {Space, Table, Typography} from "antd";
import {columnsFactory} from "./statistic.columns";
import {LoadingSpin} from "../../common/loading-spin/loading.spin";

export const AccountingStatistic: React.FC<ComponentPropsFromRoute> = ({name}) => {
    const t = useTranslate();

    const [loading, setLoading] = useState<boolean>(false);
    const [items, setItems] = useState<AccountingSummaryItem[]>([]);
    const columns = useMemo(() => columnsFactory(t), [])

    useEffect(() => {
        setLoading(true);
        summaryService.getSummary().then(items => {
            setItems(items)
            setLoading(false)
        })
    }, []);

    if (loading) {
        return <LoadingSpin />
    }

    return (
        <Space direction={"vertical"} size={[40, 40]}>
            <DocumentsMenu />
            <Space direction={"vertical"} size={[0, 0]}>
                <Typography.Title level={3}>{t("ACCOUNTING.STATEMENTS.TITLE")}</Typography.Title>
                <Table
                    columns={columns}
                    dataSource={items}
                    pagination={false}
                />
            </Space>
        </Space>
    );
}